<div
  [attr.id]="getConfig.elementId || null"
  [attr.data-ua-id]="trackingId"
  [ngClass]="'callout-' + getConfig.color"
  class="callout"
>
  <ng-content />
</div>
